import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of, combineLatest } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApisService } from '../../services/apis.service';

@Injectable({ providedIn: 'root' })
export class UnsubscribeManagementGuard implements CanActivate {
  constructor(private router: Router, private apiService: ApisService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
     const hidePhiAccess$ = this.apiService.getUserProfileDetail().pipe(
      map((result: any) => !!result?.data?.hidePhiInCampaign),
      catchError(() => of(false))
    );
    const hasPermission$ = this.apiService.getValidPermission('CMT Unsubscribe Management Show', false).pipe(
      map((result: any) => !!result?.data?.hasPermission),
      catchError(() => of(false))
    );

    return combineLatest([hidePhiAccess$, hasPermission$]).pipe(
      map(([hidePhiAccess, hasPermission]) => {
        if (!hidePhiAccess && hasPermission) {
          return true;
        }

        const fullUrl = state.url || '/';
        const pathOnly = fullUrl.split(/[?#]/)[0];
        const parentPath = pathOnly.replace(/\/[^\/]*$/, '') || '/';

        return this.router.parseUrl(parentPath);
      }),
      catchError((err) => {
        const fullUrl = state.url || '/';
        const pathOnly = fullUrl.split(/[?#]/)[0];
        const parentPath = pathOnly.replace(/\/[^\/]*$/, '') || '/';
        return of(this.router.parseUrl(parentPath));
      })
    );
  }
}
